function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.52998 17.65L2.86998 18.21V9.18L0.439977 15.04C0.0299771 16.06 0.519977 17.23 1.52998 17.65ZM21.03 13.95L16.07 1.98C15.76 1.23 15.03 0.77 14.26 0.75C14 0.75 13.73 0.79 13.47 0.9L6.09998 3.95C5.34998 4.26 4.88998 4.98 4.86998 5.75C4.85998 6.02 4.90998 6.29 5.01998 6.55L9.97998 18.52C10.29 19.28 11.03 19.74 11.81 19.75C12.07 19.75 12.33 19.7 12.58 19.6L19.94 16.55C20.96 16.13 21.45 14.96 21.03 13.95ZM11.83 17.75L6.86998 5.79L14.22 2.75H14.23L19.18 14.7L11.83 17.75Z",
  fill: "#131313"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.88 17.7499C4.88 18.8499 5.78 19.7499 6.88 19.7499H8.33L4.88 11.4099V17.7499Z",
  fill: "black",
  fillOpacity: 0.54
});

var SvgExplodedViewFile = function SvgExplodedViewFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExplodedViewFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exploded-view-file.1fee9440.svg";
export { ForwardRef as ReactComponent };